import React, { useCallback, useRef, useEffect, useMemo } from "react";
import {

  Row,
  Col
} from "reactstrap";
import "nouislider/distribute/nouislider.css";
import { motion, AnimatePresence } from "framer-motion";
import { useFeira } from "../../Contexts/FeiraContext";
import LegendaCores from "../../Components/Common/LegendaCores";
import MapaVisualizador from '../../Components/Common/MapaIndependente';
import { useLocation } from "react-router-dom";

const TelaMapaFeira = () => {
  const location = useLocation();
  
  const isVisualizacaoInterna = location.pathname.startsWith('/mapa-vendas');

  document.title = "Evomap - Tecnologia que conecta negócios - Vendas";

  const {
    mostrarFiltros,
    filtros,
    setFiltros,
    handleAplicarFiltros,
    estandeAlugado,
    setMostrarFiltros,
    corReservado,
    corLivre,
    corVendido,
    handleRemoverFiltros,
    mensagemEstandeAlugado,
    corPrincipal,
    mostrarMapaGeral,
    setMostrarMapaGeral,
    logoDesenvolvedorMapa,
    isMobile,
    setOpenMobile,
    setSelectedEstandeInfo,
    estaFiltrado,
    setEstaFiltrado,
    modoRenovacao,
    corRenovacao,
    filteredHashes,
    corPendenteRenovacao
  } = useFeira();

  const mapaRef = useRef(null);

  const formatCurrencyInput = (value) => {
    let num = value.replace(/\D/g, '');
    
    num = (num / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    return num;
  };

  const parseCurrencyInput = (value) => {
    return parseFloat(value.replace(/[^\d,-]/g, '').replace(',', '.')) || 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name.includes('valor')) {
      const formattedValue = formatCurrencyInput(value);
      setFiltros(prev => ({ ...prev, [name]: formattedValue }));
    } else {
      setFiltros(prev => ({ ...prev, [name]: value }));
    }
  };

  const aplicarFocoNosFiltros = useCallback(() => {
    if (!mapaRef.current || !filteredHashes || filteredHashes.size === 0) return;
    
    setTimeout(() => {
      if (mapaRef.current && mapaRef.current.focusOnElements) {
        const success = mapaRef.current.focusOnElements(Array.from(filteredHashes), 100);
        
        if (!success) {
          if (mapaRef.current.resetAndZoom) {
            mapaRef.current.resetAndZoom(0.7);
          } else if (mapaRef.current.resetZoom) {
            mapaRef.current.resetZoom();
          }
        }
      } else {
        if (mapaRef.current && mapaRef.current.resetZoom) {
          mapaRef.current.resetZoom();
        }
      }
    }, 400); 
  }, [filteredHashes]);

  const handleAplicarFiltrosComReset = () => {
    handleAplicarFiltros();
    setTimeout(() => {
      if (filteredHashes && filteredHashes.size > 0) {
        
        aplicarFocoNosFiltros();
      } else {
        if (mapaRef.current && mapaRef.current.resetAndZoom) {
          mapaRef.current.resetAndZoom(0.6);
        } else if (mapaRef.current && mapaRef.current.resetZoom) {
          mapaRef.current.resetZoom();
        }
      }
    }, 500);

    setMostrarFiltros(false);
  };

  const handleRemoverFiltrosComReset = () => {
    handleRemoverFiltros();
    setTimeout(() => {
      if (mapaRef.current && mapaRef.current.resetAndZoom) {
        mapaRef.current.resetAndZoom(0.8);
      } else if (mapaRef.current && mapaRef.current.resetZoom) {
        mapaRef.current.resetZoom();
      }
    }, 300);
  };

  const aplicarFiltroComZoom = () => {
    handleAplicarFiltros();
    
    if (mapaRef.current?.resetZoom) {
      mapaRef.current.resetZoom();
    }

    setMostrarFiltros(false);
  };

  const removerFiltroComZoom = () => {
    handleRemoverFiltros();

    if (mapaRef.current?.resetZoom) {
      mapaRef.current.resetZoom();
    }

    setMostrarFiltros(false);
  };

  const isTotemMode = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const forceTotem = params.get("totem") === "1";

    const isLargeLandscape =
      window.innerWidth >= 1600 &&
      window.innerWidth > window.innerHeight;

    const hasTouch =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    return forceTotem || (isLargeLandscape && hasTouch);
  }, []);

  useEffect(() => {
    const safeArea = isTotemMode ? "70px" : "0px";
    document.documentElement.style.setProperty("--map-bottom-safe-area", safeArea);

    return () => {
      document.documentElement.style.setProperty("--map-bottom-safe-area", "0px");
    };
  }, [isTotemMode]);

  // const handleRefreshPagina = useCallback(() => {
  //   window.location.reload();
  // }, []);

  const handleRefreshPagina = useCallback(() => {
    // Em vez de reload puro, força a URL atual para garantir o match
    window.location.href = window.location.pathname; 
  }, []);

  useEffect(() => {
    if (mapaRef.current?.resetZoom) {
      mapaRef.current.resetZoom();
    }
  }, [estaFiltrado]);

  return (
    <React.Fragment>
      <>
      <main className={`map-panel ${isTotemMode ? "totem-mode" : ""}`}>
        {mensagemEstandeAlugado && (
          <div
            className="alert alert-warning alert-border-left alert-dismissible fade shadow show"
            role="alert"
          >
            <i className="ri-alert-line me-3 align-middle fs-16"></i>
            <strong>Aviso </strong>
            Espaço indisponível!
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        )}
        <AnimatePresence>
          {mostrarFiltros && (
            <div className="relative w-full max-w-md mx-auto" style={{ 
                position: isMobile ? "relative" : "fixed",
                top: isMobile ? "0" : "calc(100px + 1rem)", 
                right: 0,
                transform: "translateX(-50%)",
                zIndex: 1000,
                width: "100%",
                maxWidth: "600px",
              }}>
              
              <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                  className="modal-filtros bg-white shadow-lg p-4 rounded-lg w-full"
                  style={{ 
                    maxHeight: isMobile ? "90vh" : "90vh",
                    overflowY: "auto",
                  }}
                >
              <div
                className="mb-3"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    onClick={() => setMostrarFiltros(false)}
                    className="btn btn-link btn-sm"
                    style={{
                      fontSize: "18px",
                      color: "#333",
                      textDecoration: "none"
                    }}
                    aria-label="Fechar filtros"
                  >
                    <i className="ri-close-line"></i>
                  </button>
                </div>

                <label
                  style={{
                    color: "#495057",
                    fontSize: "14px",
                  }}
                  className="block text-sm font-semibold"
                >
                  Valor do Espaço
                </label>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                  className="flex gap-2"
                >
                  <input
                    type="text"
                    name="valorMin"
                    value={filtros.valorMin}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const parsedValue = parseCurrencyInput(e.target.value);
                      setFiltros(prev => ({ ...prev, valorMin: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="R$ 1.500,00"
                    style={{ width: "100%", borderRadius: "5px" }}
                  />
                  <p
                    style={{
                      marginBottom: 0,
                      color: "rgba(73, 80, 87)",
                    }}
                  >
                    até
                  </p>
                  <input
                    type="text"
                    name="valorMax"
                    value={filtros.valorMax}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const parsedValue = parseCurrencyInput(e.target.value);
                      setFiltros(prev => ({ ...prev, valorMax: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="R$ 1.500,00"
                    style={{ width: "100%", borderRadius: "5px" }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label
                  style={{
                    color: "#495057",
                    fontSize: "14px",
                  }}
                  className="block text-sm font-semibold"
                >
                  Altura
                </label>
                <div
                  style={{
                    display: "flex",
                  }}
                  className="flex gap-2"
                >
                  
                  <input
                    type="text"
                    name="alturaMin"
                    value={filtros.alturaMin}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const parsedValue = parseCurrencyInput(e.target.value);
                      setFiltros(prev => ({ ...prev, alturaMin: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Min"
                    style={{ width: "100%", borderRadius: "5px" }}
                  />
                   <input
                    type="text"
                    name="alturaMax"
                    value={filtros.alturaMax}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const parsedValue = parseCurrencyInput(e.target.value);
                      setFiltros(prev => ({ ...prev, alturaMax: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Max"
                    style={{ width: "100%", borderRadius: "5px" }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label
                  style={{
                    color: "#495057",
                    fontSize: "14px",
                  }}
                  className="block text-sm font-semibold"
                >
                  Área Total
                </label>
                <div
                  style={{
                    display: "flex",
                  }}
                  className="flex gap-2"
                >
                  <input
                    type="text"
                    name="areaMin"
                    value={filtros.areaMin}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const parsedValue = parseCurrencyInput(e.target.value);
                      setFiltros(prev => ({ ...prev, areaMin: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Min"
                    style={{ width: "100%", borderRadius: "5px" }}
                  />
                  <input
                    type="text"
                    name="areaMax"
                    value={filtros.areaMax}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const parsedValue = parseCurrencyInput(e.target.value);
                      setFiltros(prev => ({ ...prev, areaMax: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Max"
                    style={{ width: "100%", borderRadius: "5px" }}
                  />
                  
                </div>
              </div>

              <div className="mb-3">
                <label
                  style={{
                  color: "#495057",
                  fontSize: "14px",
                  }}
                  className="block text-sm font-semibold">
                  Nome
                </label>
                <div
                  style={{
                  display: "flex",
                  }}
                  className="flex gap-2">
                    <input
                      type="text"
                      name="nome"
                      value={filtros.nome}
                      onChange={handleChange}
                      onBlur={(e) => {
                        setFiltros(prev => ({ ...prev, nome: e.target.value }));
                      }}
                      className="w-full border rounded-lg p-2 mt-1"
                      placeholder="nome do espaço, expositor ..."
                      style={{ width: "100%", borderRadius: "5px" }}
                    />
                </div>
              </div>

              <div className="gap-2" style={{ display: "flex" }}>
                <button
                  style={{ width: "100%" }}
                  onClick={aplicarFiltroComZoom}
                  type="button"
                  className="btn btn-soft-primary waves-effect waves-light shadow-none"
                >
                  Aplicar
                </button>
                <button
                  style={{ width: "100%" }}
                  onClick={removerFiltroComZoom}
                  type="button"
                  className="btn btn-ghost-danger waves-effect waves-light shadow-none"
                >
                  Remover
                </button>
              </div>
            </motion.div>
          </div>)}
        </AnimatePresence>

        <div className="map-header">
            <Row style={{ justifyContent: 'space-between', position: 'relative' }}>
              <Col xl={8}>
                <LegendaCores
                  corLivre={corLivre}
                  corReservado={corReservado}
                  corVendido={corVendido}
                  corRenovacao={corRenovacao}
                  exibeRenovacao={modoRenovacao}
                  corPendenteRenovacao={corPendenteRenovacao}
                  textoLivre="Disponível"
                  textoReservado="Reservado"
                  textoVendido="Vendido"
                  tamanhoQuadrado={15}
                  espacamento={4}
                  colunas={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 4 }}
                />

              </Col>
              <Col xl={4}>
                <div className="d-flex align-items-center gap-2" style={{ justifyContent: 'end'}}>
                  <button 
                    type="button" 
                    className="btn btn-secondary "
                    style={{
                        backgroundColor: corPrincipal,
                        color: "white",
                        border: "none",
                        padding: "0.5rem 1rem",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: 500,
                        marginLeft: "50px"
                      }}
                      onClick={() => setMostrarFiltros(!mostrarFiltros)}>
                      Filtros
                  </button>
                  {!isVisualizacaoInterna && (
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleRefreshPagina}
                      title="Atualizar página"
                      aria-label="Atualizar página"
                      style={{height: 40, padding: 4, borderRadius: 5 }}
                    >
                      <i className="ri-refresh-line" style={{ fontSize: 18, color:"white" }} /><span>{' Atualizar'}</span>
                    </button>
                  )}
                  
                </div>
              </Col>
              
          </Row>
        </div>

        <div className="map-inner-frame">
          <MapaVisualizador ref={mapaRef}/>
          
          {
            logoDesenvolvedorMapa && (
              <img
                src={logoDesenvolvedorMapa}
                alt="Logo do Desenvolvedor do Mapa"
                style={{
                  width: "100%",
                  maxWidth: "4rem",
                  position: "fixed",
                  bottom: "calc(var(--map-bottom-safe-area, 0px) + 10px)",
                  right: "30px",
                  zIndex: 9999
                }}
              />
            )
          }
        </div>

      </main>


      {!isMobile  && !isVisualizacaoInterna && (
        <button
          onClick={() => { setOpenMobile(true); setSelectedEstandeInfo(null); }}
          style={{
            position: "fixed",
            bottom: "calc(var(--map-bottom-safe-area, 0px) + 16px)",
            left: "calc(22rem + 16px)",
            zIndex: 10,
            backgroundColor: corPrincipal,
            color: "#fff",
            border: "none",
            borderRadius: "30px",
            padding: "10px 16px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "14px",
            margin: 0
          }}
        >
          <i className="ri-information-line" style={{ fontSize: '18px' }}></i>
          Ver informações da feira
        </button>
      )}
        
      </>
    </React.Fragment>
  );
};

export default TelaMapaFeira;
